export enum LastUsedAuthenticationMethod {
  Unknown = 0
}
